import React, { useEffect, useState } from "react";
import "./TableInfoHeader.scss";
import { Box, Typography, Button, Chip, Autocomplete, TextField, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from '@mui/icons-material/FilterList';
import { useSelector } from "react-redux";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

function TableInfoCRM({
  count,
  setFilter,
  setCountryFilter,
  previousUserData,
  deleteItemById,
  handleSelectedUser,
  setOpenButton,
  countryFilter,
  filterRole,
  setFilterRole,
  systemRoles
}) {

  const [isFilterVisible, setIsFilterVisible] = useState(false); // State to toggle filter section
  const [activeFilter, setActiveFilter] = useState(null);
  const [profileStatus, setProfileStatus] = useState(null);

  const requiredConstants = useSelector((state) => state.constants);

  const profileStatuses = async () => {
    const payload = requiredConstants.profileStatus || [];
    console.log("payload-------",payload);

    const filteredPayload = payload.filter(item => {
      const name = item.userprofilestatus.name;

      return ![
          "Business Case Development",
          "Business Case Review",
          "Level 2 Vetting"
      ].includes(name);
  });

    // Transform payload into { label, value } format
    const formattedProfileStatus = filteredPayload.map(item => ({
        label: item?.userprofilestatus?.name,
        value: item?.userprofilestatus?.statusID,
        key: item?.userprofilestatus?.statusID
    }));

    formattedProfileStatus.unshift({
        label: "Closed",
        value: "4",
        key: "4"
    });

    setProfileStatus(formattedProfileStatus);
    // console.log(formattedProfileStatus);
  };


  useEffect(() => {
    profileStatuses();
  }, []);

  // Function to set both the active filter for highlighting and the filter for functionality
  const handleFilterClick = (e, filter) => {
    // console.log(e, filter)
    setActiveFilter(filter);
    setFilter(filter); 
    setFilterRole([]);
  };

  const countries = useSelector(
    (state) => state.constants.formSelectData.country
  );

  // console.log(countries)

  const handleCountryFilter = (e, newValue) => {
    setCountryFilter(newValue);
  };

  return (
    <Box 
      className="table-info-header" 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "flex-start",
        padding: 0, 
        margin: 0,
      }}
      >
      <Box
        sx={{
          display: "flex",
          width: "100%", 
        }}
      >
        <Box
          className="previously-viewed-accounts"
          sx={{ flex: 1, marginRight: "16px" }}
        >
          <Typography variant="text" sx={{fontSize: "14px"}}>
            Previously Viewed Accounts:
          </Typography>
          <Box
            className="chip-container"
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {previousUserData.map((user, index) => (
              <Chip
                key={user.id}
                // label={decodeHtmlEntities(`${user.firstName} ${user.lastName}`)}
                label={decodeHtmlEntities(
                  user.firstName?.trim() && user.lastName?.trim()
                    ? `${user.firstName} ${user.lastName}`
                    : user.otherNames
                )}
                onClick={() => {
                  handleSelectedUser(user.id);
                  setOpenButton((prevState) => ({ ...prevState, edit: true }));
                }}
                className="crm-list-chip"
                onDelete={() => deleteItemById(user.id)}
                deleteIcon={<CloseIcon className="chip-delete-icon" sx={{ color: index === 0 ? "#008ECC !important" : "#000000 !important" }} />}
                variant="outlined"
                sx={{
                  backgroundColor: "#ffffff", // Highlight the last item
                  borderColor: index === 0 ? '#008ECC' : "#000000",
                  color: index === 0 ? "#008ECC" : "#000000",
                  display: "flex",
                  flexDirection: "row-reverse",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
            ))}
          </Box>
        </Box>

        <Box className="table-options">
          <Button className="filter-button" sx={{ textTransform:"capitalize" }} onClick={() => {setIsFilterVisible(!isFilterVisible);}} endIcon={<FilterListIcon />}> Filter </Button>
          <Button className="filter-button" sx={{ textTransform:"capitalize" }} onClick={() =>{ 
            setCountryFilter(null); setActiveFilter(null); handleFilterClick(null)
          }}>Clear Filter</Button>
        </Box>
      </Box>

      {isFilterVisible && (
        <>
          <Box 
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "30px",
              marginTop: "10px",
              padding: "10px",
              backgroundColor: "#FFFFFF",
              borderRadius: "5px",
              width: "100%",
            }}
          >

            <Box
              className="chip-container"
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                mt: "5px",
              }}
            >
              <Typography sx={{ fontFamily: "Nunito", color: "#333", mr: 1 }}>Filter: </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ display: "flex", mb: 2 }}>
                <Autocomplete
                  options={profileStatus || []}
                  getOptionLabel={(option) => option.label} 
                  value={activeFilter}
                  onChange={handleFilterClick}
                  renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select User Status"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: "40px",
                            "& .MuiInputBase-input": { padding: "10px 14px" },
                            "& .MuiAutocomplete-endAdornment": { display: "flex", alignItems: "center", flexDirection: "row" },
                            "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator": { backgroundColor: "transparent", border: "none" },
                          },
                        }}
                      />
                    )}              
                    sx={{ 
                    width: "250px",
                    height: "30px",
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <Autocomplete
                  options={countries || []}
                  getOptionLabel={(option) => option.label} 
                  value={countryFilter}
                  onChange={handleCountryFilter}
                  renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Country"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: "40px",
                            "& .MuiInputBase-input": {padding: "10px 14px", },
                            "& .MuiAutocomplete-endAdornment": { display: "flex", alignItems: "center", flexDirection: "row" },
                            "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator": { backgroundColor: "transparent", border: "none" },
                          },
                        }}
                      />
                    )}              
                    sx={{ 
                    width: "250px",
                    height: "30px",
                  }}
                />
              </Box>
            </Box>
          </Box>
          <Box sx={{width: "100%"}}>
            <Divider sx={{ my: 2, border: "1px solid #A9A9A9" }} />
          </Box>
        </>
      )}

      <Typography
        className="total-count"
        sx={{
          marginTop: 2,
          fontWeight: "bold",
        }}
      >
        Total: {count ? count : "0"} Users
      </Typography>
    </Box>
  );
}

export default TableInfoCRM;
